import { lazy } from 'react'
import RequireAuthentication from '@/router/guards/RequireAuthentication'

const Screening = lazy(() => import('./pages/ContextualScreen'))
const ScreeningWrapper = lazy(() => import('./pages/ScreeningWrapper'))
const GuideConsult = lazy(() => import('../Attendance/components/GuideConsult'))

const AuthRoutes = [
  <RequireAuthentication
    exact
    path="/triagem/"
    key="/triagem/"
    component={Screening}
  />,
  <RequireAuthentication
    exact
    path="/triagem/:step"
    key="/triagem/:step"
    component={ScreeningWrapper}
  />,
  <RequireAuthentication
    exact
    path="/guia-consulta"
    key="/guia-consulta"
    component={GuideConsult}
  />,
]

export default AuthRoutes
